import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'folder-encrypted-success',
  templateUrl: './folder-encrypted-success.component.html',
  styleUrls: ['./folder-encrypted-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderEncryptedSuccessComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<FolderEncryptedSuccessComponent>) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
